import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';

const StockApplyModal = ({ stockRate, repaymentQtyAmount }) => {
    const {
        PayOffStore: {
            stockList,
            stockApplyModalVisible,
            closeStockApplyModal,
            getApplyRepayment,
            applyDisabled,
        },
        AuthStore: { account, updateUserInfo, borrowingAmount },
    } = useStore();
    const stockArr = stockList.filter(stock => stock.repaymentQty > 0);
    let stockAmount = 0;
    for (const i in stockArr) {
        stockAmount += stockArr[i].repaymentQty;
    }

    return (
        <Modal
            show={stockApplyModalVisible}
            onHide={closeStockApplyModal}
            title={'確認還款資料'}
        >
            <form
                onSubmit={async e => {
                    e.preventDefault();
                    closeStockApplyModal();
                    await getApplyRepayment(account);
                    updateUserInfo();
                }}
            >
                <h4 className=" title fw-bolder  mb-2">請您確認以下申請資料</h4>
                <h5 className=" title mt-3 mb-1">使用以下庫存作為擔保品</h5>
                <div className="stock-inv d-flex flex-nowrap justify-content-between align-items-center px-3  px-md-2 pt-2 pb-1  mb-4">
                    <div className="stock-scrol col-9 col-sm-10  table-responsive-lg ">
                        {stockArr.map((cst, index) => {
                            return (
                                <div
                                    key={`stock_${index}`}
                                    className="stock-card  text-center  rounded-2 bg-white fs-12 me-2  mb-1 float-start"
                                >
                                    <div className="stock-name text-black2 p-2 ">
                                        <span>{cst.stockName}</span>
                                        <small className="gray-light ms-1">
                                            {cst.stockNo}
                                        </small>
                                    </div>
                                    <div className="stock-number text-white rounded-bottom">
                                        {cst.repaymentQty}
                                        <small>張</small>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="fs-15 text-center col-3 col-sm-2">
                        合計
                        <b className="num text-orange mx-1">{stockAmount}</b>張
                    </div>
                </div>
                <p className="caln-num mb-4 text-black">
                    賣出以上擔保品，試算維持率為
                    <span className="p-1 rounded-2 ms-2">
                        {stockRate <= 0 || repaymentQtyAmount >= borrowingAmount
                            ? 0
                            : Math.floor(stockRate * 100) / 100}
                        %
                    </span>
                </p>
                <div className="pop-notice ">
                    <p className="not_title mb-1"> 注意事項</p>
                    <ul>
                        <li className="text-danger ">
                            申請賣股還款前請自行至交易平台賣出股票。
                        </li>
                        <li className="text-danger ">
                            此為申請償還張數，實際償還張數依您成交張數計算。
                        </li>
                        <li className="text-danger ">
                            若您未提出賣股還款申請，賣出股票沖銷順序：現股優先，其次擔保品(賣股還款)。
                        </li>
                    </ul>
                </div>
                <div className="mob-fix-bottom  btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                    <button
                        className="btn_cancel btn rounded-pill  text-sm-center"
                        type="button"
                        onClick={() => {
                            closeStockApplyModal();
                        }}
                    >
                        回上一步
                    </button>
                    <button
                        className=" btn_check btn rounded-pill text-white "
                        type="submit"
                        disabled={applyDisabled}
                    >
                        確認申請
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default observer(StockApplyModal);
